// extracted by mini-css-extract-plugin
export default {"notice":"Notice_notice__8nEYa","actions":"Notice_actions__QyAMi","document_info":"Notice_document_info__v3IMa"};